import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const features = [{
  title: 'Lectura bíblica guiada',
  desc: 'directamente del libro de Ester, con contexto revelador'
}, {
  title: 'Reflexión profunda',
  desc: 'preguntas que van al corazón, no a la superficie'
}, {
  title: 'Declaración de fe',
  desc: 'palabras para hablar sobre tu vida con autoridad'
}, {
  title: 'Oración activadora',
  desc: 'no para pedir, sino para posicionarte'
}, {
  title: 'Espacio de escritura personal',
  desc: 'porque tu historia merece ser registrada'
}];
export function IncludedFeatures() {
  return <section className="py-8 px-5 bg-navy-800/20" data-id="element-203">
      <div className="max-w-lg mx-auto" data-id="element-204">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-205">
          <div className="text-center mb-6" data-id="element-206">
            <p className="text-gold-400 font-medium text-sm mb-1" data-id="element-207">
              Esto no es teoría.
            </p>
            <h2 className="font-serif text-2xl text-cream-100" data-id="element-208">
              Es transformación.
            </h2>
            <p className="text-cream-300/80 text-sm mt-2" data-id="element-209">Cada día incluye:</p>
          </div>

          <div className="space-y-2.5" data-id="element-210">
            {features.map((feature, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-3 bg-navy-900/50 p-3 rounded-sm border border-gold-500/10" data-id="element-211">
                <div className="mt-0.5 flex-shrink-0 w-5 h-5 rounded-full bg-gold-500/10 flex items-center justify-center text-gold-400" data-id="element-212">
                  <Check size={12} strokeWidth={3} data-id="element-213" />
                </div>
                <div data-id="element-214">
                  <span className="font-serif text-cream-100 text-base block leading-tight" data-id="element-215">
                    {feature.title}
                  </span>
                  <span className="text-cream-300/70 text-[13px] font-light" data-id="element-216">
                    — {feature.desc}
                  </span>
                </div>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}